import { HttpClient } from "@angular/common/http";
import { Component, OnInit, Optional, inject, input, isDevMode } from "@angular/core";
import { NZ_MODAL_DATA, NzModalRef } from "ng-zorro-antd/modal";
import { AccountService } from "../../account.service";
import { ActivatedRoute, Router } from "@angular/router";
import { PlatformType } from "@root/config";
import { postMsg } from "@root/router/public/h5/channel/util";
interface NzData {
  thirdpartyAccount: string;
}

@Component({
  selector: "host-connect-with-ctrip",
  templateUrl: "./connect-with-ctrip.component.html",
  styleUrls: ["./connect-with-ctrip.component.scss"],
})
export class V4ConnectWithCtripComponent implements OnInit {
  footerClass = `
    fixed bottom-[20px] left-[20px] right-[20px] flex flex-col-reverse
    md:flex-row md:justify-end md:relative md:mt-12 md:bottom-0 md:left-auto md:right-0
  `;
  footerCancelBtnClass = `
    w-full
    md:mr-3 md:w-auto
  `;
  footerConfirmBtnClass = `
    w-full mb-2
    md:mb-0 md:w-auto
  `;
  step = 1;
  username;
  hotelIds = [{ value: null }];
  loading = false;

  nzData: NzData = inject(NZ_MODAL_DATA, { optional: true });

  constructor(
    @Optional() private modalRef: NzModalRef,
    private http: HttpClient,
    private accountSrv: AccountService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    console.log("nzData: ", this.nzData);
    /**
     * 有传递 thirdpartyAccount，则认为是更新用户名
     */
    if (this.nzData?.thirdpartyAccount) {
      this.step = 99;
    }
  }

  private requestAuth() {
    const params = {
      username: this.username,
      hotel_ids: this.hotelIds?.map((i) => i.value),
    };
    return this.accountSrv.accountAuth("cmtrip", params);
    // return this.http.post('/api/thirdparty/auth/cmtrip', params);
  }

  private requestUpdateUsername() {
    const params = {
      thirdparty_account_id: this.nzData.thirdpartyAccount,
      username: this.username,
    };
    this.http.post("/api/thirdparty/update_trip_username", params).subscribe((rst: any) => {
      this.loading = false;

      if (isDevMode() || rst?.error_code === 0) {
        this.modalRef.destroy();
      }
    });
  }

  onUpdateUsername() {
    this.loading = true;
    this.requestUpdateUsername();
  }

  onCancel() {
    if (this.modalRef) {
      this.modalRef.destroy();
    } else {
      postMsg("BACK");
    }
    // this.modalRef?.destroy();
  }

  onNext() {
    this.loading = true;
    this.requestAuth().subscribe((rst: any) => {
      this.loading = false;
      if (rst.error_code === 0) {
        // this.step = 5;
        this.navigate();
        // this.modalRef?.destroy("success");
      }

      if (isDevMode()) {
        this.navigate();
      }
    });
  }

  // onFinish() {
  //   this.modalRef?.destroy("success");
  // }

  onAddHotelId() {
    this.hotelIds.push({ value: null });
  }

  onRemoveHotelId(index) {
    this.hotelIds.splice(index, 1);
  }

  private navigate() {
    if (this.modalRef) {
      this.modalRef?.destroy("success");
    } else {
      this.router.navigate(["../set-price-ratio"], {
        relativeTo: this.route,
        queryParams: { thirdparty_type: PlatformType.CtripOffical },
      });
    }
  }
}
